import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * The single place a margin decimal string is coerced to a number. Exact at these
 * magnitudes: two-decimal amounts sit far below the integer-precision limit. No margin
 * figure is ever accumulated or averaged on the client — every total arrives precomputed.
 */
export function parseMarginAmount(amount: string | Nullish): number | null {
  if (isNil(amount)) {
    return null;
  }

  return Number(amount);
}
